module.exports = __webpack_public_path__ + "img/laravel-fullstack-app8.c13755e8.png";